module.exports = __webpack_public_path__ + "d120e398d49160b60c7205b43b757111.svg";